import Controller from '../abstracts/Controller';
import 'scss-templates/t-my-account.scss';

export default class MyAccountController extends Controller {
  static get COMPONENTS() {
    return [
      'LoginComponent',
      'MyaccountAddressesComponent',
      'ChangePasswordComponent',
      'ShowPasswordComponent',
      'MyaccountPaymentsComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'SizeSelectorComponent',
      'NotifyMeComponent',
      'AddToCartComponent',
      'CreditCardValidator',
      'O2OComponent',
      'ProfileComponent',
      'ProfileFormComponent',
      'PrivacyUnsubscribeComponent',
      'CustomSelectComponent',
      'ShowFormComponent',
      'DatePickerComponent',
      'EgonValidationComponent'
    ];
  }
}
